<template>
  <v-card>
    <v-list>
      <v-list-item>
        <SearcherCookingMethod
          v-model="cook_method"
          :disabledItems="disabledPractices"
          dense
          unclearable
        />
      </v-list-item>
    </v-list>
    <v-divider></v-divider>
    <v-list>
      <v-list-item>
        <SearcherRecipe
          v-model="recipe"
          :disabledItems="disabledRecipes"
          dense
          unclearable
        />
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import SearcherCookingMethod from "@/components/plugins/SearcherCookingMethod";
import SearcherRecipe from "@/components/plugins/SearcherRecipe";

export default {
  name: "EditRelations",

  props: ["value", "relations"],

  components: {
    SearcherCookingMethod,
    SearcherRecipe,
  },

  data: () => ({
    cook_method: {},
    disabledPractices: [],
    recipe: {},
    disabledRecipes: [],
  }),

  watch: {
    relations: {
      immediate: true,
      deep: true,
      handler() {
        if (this.relations) {
          this.relations.map((r) => {
            this.disabledPractices.push({ id: r.food_behavior_id });
            this.disabledRecipes.push({ id: r.food_formula_id });
          });
        }
        this.$emit("updateRelations", this.relations);
      },
    },
    cook_method: {
      handler() {
        if (
          Object.keys(this.cook_method).length &&
          Object.keys(this.recipe).length
        ) {
          this.relations.push({
            new: this.relations.length + 1,
            food_behavior_id: this.cook_method.id,
            food_behavior: this.cook_method,
            food_formula_id: this.recipe.id,
            food_formula: this.recipe,
            food_id: this.dishId,
          });
          this.cook_method = {};
          this.recipe = {};
        }
      },
    },
    recipe: {
      handler() {
        if (
          Object.keys(this.cook_method).length &&
          Object.keys(this.recipe).length
        ) {
          this.relations.push({
            new: this.relations.length + 1,
            food_behavior_id: this.cook_method.id,
            food_behavior: this.cook_method,
            food_formula_id: this.recipe.id,
            food_formula: this.recipe,
            food_id: this.dishId,
          });
          this.cook_method = {};
          this.recipe = {};
        }
      },
    },
  },
};
</script>